<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row>
        <b-col class="d-flex justify-content-between align-items-center">
          <h1 v-if="actualProduct.id > 0">
            Producto
            {{ this.actualProduct.id + " " + this.actualProduct.ndescription }}
          </h1>
          <h1 v-else>Crear Producto</h1>
          <b-button v-if="actualProduct.id > 0" size="sm" variant="outline-secondary"
            @click="$refs.productAudit.open()">
            <i class="fas fa-history"></i> Historial
          </b-button>
        </b-col>
      </b-row>
      <audit-trail-modal ref="productAudit" table-name="product" :record-id="actualProduct.id"
        modal-id="product-audit-modal" title="Historial del producto" />
      <b-card>
        <b-row>

          <b-col lg="3" md="12" class="d-flex flex-column">
            <div class="mb-3 d-flex justify-content-center">
              <image-uploader v-if="actualProduct.id > 0" :url="'product/' + actualProduct.id + '/image'"
                :output-size="512" @uploaded="getProduct"></image-uploader>
              <small v-else class="text-muted">Guarda el producto para poder subir su imagen.</small>
            </div>
            <div class="d-flex justify-content-center">
              <b-img fluid v-if="actualProduct.image" rounded="true" :key="actualProduct.image"
                :src="axios.defaults.baseURL + '/' + actualProduct.image" class="product-image-preview" />
            </div>

          </b-col>
          <b-col lg="9" md="12">
            <b-row>
              <b-col md="6" sm="12">
                <b-form-group label="Clave:">
                  <b-form-input v-model="actualProduct.clave" type="text" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6" sm="12">
                <b-form-group label="Codigo de barra:">
                  <b-form-input v-model="actualProduct.barcode" type="text" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="6" md="12">
                <b-form-group label="Nombre:">
                  <b-form-input v-model="actualProduct.ndescription" type="text" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="6" md="12">
                <b-form-group label="Nombre Corto (boton captura tactil):">
                  <b-form-input v-model="actualProduct.short_name" type="text" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="6" md="12">
                <b-form-group label="Nota de captura (recordatorio al vender):">
                  <b-form-input v-model="actualProduct.pos_note" type="text" placeholder="Ej. preguntar término, el combo incluye refresco"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="6" md="12">
                <b-form-group label="Descripción:">
                  <b-form-textarea v-model="actualProduct.description" rows="2" max-rows="4" placeholder="Descripción del producto"></b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col xl="4" md="4" sm="12">
                <b-form-group label="Status:">
                  <b-form-select v-model="actualProduct.status" :options="statusoptions"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col xl="4" md="4" sm="12">
                <b-form-group label="Grupo:">
                  <b-form-select v-model="actualProduct.group" :options="groupOptions"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col xl="4" md="4" sm="12">
                <b-form-group label="Lealtad y beneficios:">
                  <b-form-checkbox v-model="actualProduct.loyalty_excluded">No genera puntos</b-form-checkbox>
                  <b-form-checkbox v-model="actualProduct.benefit_excluded">Excluido de beneficios</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col xl="4" md="4" sm="12">
                <b-form-group label="Area Preparacion:">
                  <b-form-select v-model="actualProduct.prep_area" :options="prepareasOptions"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col xl="4" md="4" sm="12">
                <b-form-group label="Tipo:">
                  <b-form-select v-model="actualProduct.meal_type_id" :options="mealtypesOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>


        <b-row class="mt-3">
          <b-button v-if="actualProduct.id > 0" block variant="success" @click="updateProduct">Guardar</b-button>
          <b-button v-else block variant="success" @click="updateProduct">Crear</b-button>
        </b-row>
      </b-card>
      <b-row class="mt-3" v-if="actualProduct.id > 0">
        <b-col>
          <b-card>
            <h1>Personalizaciones</h1>
            <b-button class="mb-3" variant="primary" @click="openModalPersonalization()">Agregar
              personalizacion</b-button>
            <b-table small stacked="sm" v-if="actualProduct.product_personalization.length > 0" responsive
              :fields="fieldsPersonalizations" :items="actualProduct.product_personalization">
              <template #cell(default_selected)="data">
                <b-badge pill v-if="data.item.default_selected" variant="success">SI</b-badge>
                <b-badge pill v-else-if="!data.item.default_selected" variant="danger">NO</b-badge>
              </template>
              <template v-slot:cell(edit)="data">
                <b-button size="sm" variant="danger"
                  @click="deleteProductPersonalization(data.item)">Eliminar</b-button>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="actualProduct.id > 0">
        <b-col>
          <b-card>
            <h3>Grupos de Extras</h3>
            <b-button class="mb-3" size="sm" variant="primary" :href="'/product-extra-group'">Crear Grupo de Extras</b-button>
            <b-table small stacked="sm" responsive v-if="productExtraGroups.length > 0" :items="productExtraGroups"
              :fields="fieldsExtraGroups">
              <template #cell(status)="data">
                <b-badge pill v-if="data.item.status == 1" variant="success">Activo</b-badge>
                <b-badge pill v-else variant="danger">Inactivo</b-badge>
              </template>
              <template #cell(actions)="data">
                <b-button size="sm" variant="warning" :href="'/product-extra-group/' + data.item.id">Ver</b-button>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="actualProduct.id > 0">
        <b-col>
          <b-card>
            <h1>Precios</h1>
            <b-button class="mb-3" variant="primary" @click="openModalPrice({ id: 0 })">Agregar precio</b-button>
            <b-table small stacked="sm" v-if="filteredProductPrices.length > 0" responsive
              :items="filteredProductPrices" :fields="fieldsPrices">
              <template v-slot:cell(cost)="{ item }">
                ${{ totalCostByRecipe }}...<b>{{ (totalCostByRecipe * 100 / item.price).toFixed(2) }}%</b>
              </template>
              <template #cell(area_restaurant_id)="data">
                {{
                  data.item.area_restaurant_id +
                  " " +
                  searchRestArea(data.item.area_restaurant_id).name
                }}
              </template>

              <template #cell(price)="data">
                <div v-if="editingMasterPriceId === data.item.id" style="display:flex; align-items:center; gap:4px;">
                  <b-form-input
                    size="sm"
                    type="number"
                    v-model.number="editingMasterPriceValue"
                    @keyup.enter="saveMasterPriceInline(data.item)"
                    @blur="saveMasterPriceInline(data.item)"
                    @keyup.escape="cancelMasterPriceInline()"
                    autofocus
                    style="max-width:120px"
                  ></b-form-input>
                </div>
                <div v-else @click="startEditMasterPrice(data.item)"
                     style="cursor:pointer; padding:2px 6px; border-radius:4px;"
                     class="hover-highlight">
                  ${{ data.item.price }}
                  <b-badge v-if="followerCounts[data.item.area_restaurant_id]"
                           variant="info" pill class="ml-1"
                           v-b-tooltip.hover title="Sucursales que siguen este precio">
                    {{ followerCounts[data.item.area_restaurant_id] }}
                    <b-icon icon="diagram3" font-scale="0.8"></b-icon>
                  </b-badge>
                </div>
              </template>

              <template v-slot:cell(edit_price)="data">
                <b-button size="sm" @click="openModalPrice(data.item)" variant="warning"
                          v-b-tooltip.hover title="Opciones avanzadas">
                  <b-icon icon="gear"></b-icon>
                </b-button>
                <b-button size="sm" variant="danger" @click="deleteProductPrice(data.item)">
                  <b-icon icon="trash"></b-icon>
                </b-button>
              </template>
            </b-table>
            <b-row class="mb-2">
              <b-col>
                <b-badge pill variant="success">En seguimiento</b-badge>
                <b-badge pill variant="danger">Unico</b-badge>
                <b-badge pill variant="secondary">Deshabilitado</b-badge>
              </b-col>
            </b-row>

            <b-card v-if="pivotPrices.length > 0" class="mb-3" bg-variant="light" body-class="py-2 px-3">
              <b-row align-v="end">
                <b-col md="3" sm="12">
                  <b-form-group label="Area:" class="mb-1" label-size="sm">
                    <b-form-select size="sm" v-model="batchArea" :options="optionRestAreas"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="auto" sm="12" class="mb-1">
                  <b-button size="sm" variant="success" @click="batchFollowMaster()" :disabled="batchProcessing || !batchArea"
                            v-b-tooltip.hover title="Todas las sucursales seguiran el precio master de esta area">
                    <b-icon icon="diagram3"></b-icon> Seguir master
                  </b-button>
                </b-col>
                <b-col md="auto" sm="12" class="mb-1 d-flex align-items-end" style="gap:4px;">
                  <b-form-input size="sm" type="number" v-model.number="batchPriceValue" placeholder="Precio"
                                style="max-width:100px" :disabled="batchProcessing"></b-form-input>
                  <b-button size="sm" variant="danger" @click="batchSetPrice()" :disabled="batchProcessing || !batchArea || !batchPriceValue"
                            v-b-tooltip.hover title="Establecer precio unico en todas las sucursales para esta area">
                    <b-icon icon="cash"></b-icon> Aplicar precio
                  </b-button>
                </b-col>
                <b-col md="auto" sm="12" class="mb-1">
                  <b-button size="sm" variant="outline-success" @click="batchToggleStatus(true)" :disabled="batchProcessing || !batchArea"
                            v-b-tooltip.hover title="Habilitar precio en todas las sucursales">
                    <b-icon icon="check-circle"></b-icon> Habilitar
                  </b-button>
                  <b-button size="sm" variant="outline-secondary" @click="batchToggleStatus(false)" :disabled="batchProcessing || !batchArea"
                            v-b-tooltip.hover title="Deshabilitar precio en todas las sucursales">
                    <b-icon icon="x-circle"></b-icon> Deshabilitar
                  </b-button>
                </b-col>
                <b-col md="auto" sm="12" v-if="batchProcessing" class="mb-1">
                  <b-spinner small variant="primary"></b-spinner> Procesando...
                </b-col>
              </b-row>
            </b-card>

            <b-table sticky-header small v-if="pivotPrices.length > 0" responsive :items="pivotPrices"
              :fields="fieldsPivotPrices" class="pivot-prices-table">
              <template v-slot:cell(sucursal_id)="{ item }">
                <strong>{{ searchSucursal(item.sucursal_id).nombre }}</strong>
              </template>

              <template v-for="area in restAreas" v-slot:[`cell(${area.id})`]="{ item }">
                <div v-if="editingPivotKey === item.sucursal_id + '-' + area.id" :key="'edit-' + area.id"
                     style="display:flex; align-items:center; gap:2px;">
                  <b-form-input
                    size="sm"
                    type="number"
                    v-model.number="editingPivotValue"
                    @keyup.enter="savePivotPriceInline(item, area)"
                    @blur="savePivotPriceInline(item, area)"
                    @keyup.escape="cancelPivotPriceInline()"
                    autofocus
                    style="max-width:90px"
                  ></b-form-input>
                </div>
                <div v-else :key="'disp-' + area.id" style="display:flex; align-items:center; gap:2px;">
                  <b-badge
                    :variant="(!item['s' + area.id] ? 'secondary' : item['f' + area.id] ? 'success' : 'danger')"
                    style="font-size: 0.9em; padding: 6px 10px; cursor: pointer; min-width: 60px; text-align: center;"
                    @click="startEditPivotPrice(item, area)"
                    v-b-tooltip.hover
                    :title="!item['s' + area.id] ? 'Deshabilitado' : item['f' + area.id] ? 'Sigue master' : 'Precio unico'">
                    {{ (!item['s' + area.id] ? '-' : '$' + item[area.id]) }}
                  </b-badge>
                  <b-button
                    size="sm" variant="link" class="p-0 ml-1"
                    @click="openModalPriceByPriceArea({ area_restaurant_id: area.id, sucursal_id: item.sucursal_id })"
                    v-b-tooltip.hover title="Opciones">
                    <b-icon icon="three-dots-vertical" font-scale="0.8"></b-icon>
                  </b-button>
                </div>
              </template>

            </b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="actualProduct.id > 0">
        <b-col>
          <b-card>
            <h1>Receta</h1>
            <b-button variant="primary" class="mb-3" @click="openModalRecipe({ id: 0 })">Agregar</b-button>
            <b-table small stacked="sm" responsive v-if="product_recipes.length > 0" :items="product_recipes"
              :fields="fieldsRecipe">
              <template #cell(supply_id)="data">
                <span>{{ data.item.supply_id }} {{ data.item.supply.name }}</span>
                <b-badge
                  v-if="data.item.supply._missing"
                  variant="warning"
                  class="ml-2"
                  v-b-tooltip.hover
                  title="Este insumo no está disponible en la compañía actual. Verifica si pertenece a otra compañía o fue desactivado."
                >
                  <i class="fas fa-exclamation-triangle"></i> Insumo no disponible
                </b-badge>
              </template>
              <template #cell(base_portion)="data">
                {{ data.item.supply._missing ? '—' : data.item.supply.base_portion }}
              </template>
              <template #cell(qty)="data">
                <template v-if="data.item.supply._missing">—</template>
                <template v-else>
                  {{ data.item.qty_portions * data.item.supply.base_portion }} {{ data.item.supply.unit }}
                </template>
              </template>
              <template #cell(unit)="data">
                {{ data.item.supply._missing ? '—' : data.item.supply.unit }}
              </template>

              <template #cell(supply.price)="data">
                <template v-if="data.item.supply._missing">—</template>
                <template v-else>$ {{ Number(data.item.supply.price || 0).toFixed(2) }}</template>
              </template>
              <template #cell(totalPrice)="data">
                <template v-if="data.item.supply._missing">—</template>
                <template v-else>
                  $ {{ (data.item.qty_portions * data.item.supply.price * data.item.supply.base_portion).toFixed(2) }}
                </template>
              </template>
              <template v-slot:cell(edit_supply)="data">
                <b-button
                  size="sm"
                  variant="warning"
                  :disabled="data.item.supply._missing"
                  v-b-tooltip.hover
                  :title="data.item.supply._missing ? 'No se puede editar: el insumo no está disponible en esta compañía.' : ''"
                  @click="openModalRecipe(data.item)"
                >
                  Editar
                </b-button>
                <b-button size="sm" variant="danger" @click="deleteProductRecipe(data.item)">Eliminar</b-button>
              </template>
            </b-table>
            <h3>Total: ${{ totalCostByRecipe }}</h3>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="modal-addRecipe" size="xl" title="Receta" @ok="createProductRecipe">
      <b-row>
        <b-col md="6" sm="12">
          <b-form-group label="Ingrediente:">
            <vu-select :reduce="(x) => x.value" v-model="actualRecipe.supply_id" :options="optionSupplies"></vu-select>
            <!-- <b-form-select v-model="actualRecipe.supply_id" :options="optionSupplies"></b-form-select> -->
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Porciones:">
            <b-input-group>
              <b-form-input v-model.number="supplyQty" type="number" placeholder="Porciones" required></b-form-input>
              <VueInputCalculator :is-history-logs="false" :enable-keyboard="true" v-model="supplyQty">
                <b-input-group-append>
                  <b-button variant="primary">
                    <b-icon icon="calculator"></b-icon>
                  </b-button>
                </b-input-group-append>
              </VueInputCalculator>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-price" title="Precio" @ok="createProductPrice">
      <b-row v-if="(actualPrice.sucursal_id != null)">
        <b-col>
          <b-form-group label="Master:">
            <b-form-checkbox :disabled="actualPrice.sucursal_id == null" v-model="actualPrice.follow_price">
              Sigue el precio master?
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Status:">
            <b-form-checkbox v-model="actualPrice.status">
              Habilitado
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!actualPrice.follow_price || (actualPrice.sucursal_id == null)">
        <b-col md="6" sm="12">
          <b-form-group label="Area:">
            <b-form-select v-model="actualPrice.area_restaurant_id" :options="optionRestAreas"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Precio:">
            <b-form-input v-model.number="actualPrice.price" type="number" placeholder="Precio" required></b-form-input>
          </b-form-group>
        </b-col>

      </b-row>
    </b-modal>
    <b-modal id="modal-addPersonalization" title="Personalizacion" @ok="createProductPersonalization">
      <b-row>
        <b-col md="6" sm="12">
          <b-form-group label="Personalizacion:">
            <b-form-select v-model="actualPersonalization.personalization_id"
              :options="personalizationOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Habilitada Default:">
            <b-form-checkbox v-model="actualPersonalization.default_selected">
              Default
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import ImageUploader from "../components/ImageUploader.vue";
import VueInputCalculator from "vue-input-calculator";
import AuditTrailModal from "../components/AuditTrailModal.vue";

export default {
  name: "Products",
  components: { Nav, ImageUploader, VueInputCalculator, AuditTrailModal },
  computed: {
    followerCounts() {
      var allPrices = this.actualProduct.product_prices || [];
      var counts = {};
      allPrices.forEach(function (p) {
        if (p.sucursal_id != null && p.follow_price) {
          var key = p.area_restaurant_id;
          counts[key] = (counts[key] || 0) + 1;
        }
      });
      return counts;
    },
    // Ensure the model is always a number
    supplyQty: {
      get() {
        // Convert to number in the getter
        return Number(this.actualRecipe.qty_portions);
      },
      set(newValue) {
        // Set the rawValue and force it to be a number
        this.actualRecipe.qty_portions = Number(newValue);
      }
    }
  },
  data() {
    return {
      statusoptions: [
        { value: "ACTIVE", text: "ACTIVO" },
        { value: "INACTIVE", text: "INACTIVO" },
      ],
      personalizationOptions: [],
      actualPersonalization: {
        id: 0,
        product_id: 0,
        personalization_id: 0,
        default_selected: false,
      },
      actualPrice: {
        id: 0,
        product_id: 0,
        area_restaurant_id: 0,
        price: 0,
        price_wo_tax: 0,
        tax: 0,
        tax_excempt: false,
        billable: true,
      },
      actualRecipe: {
        id: null,
        product_id: null,
        supply_id: null,
        qty_portions: 0,
      },
      actualProduct: {
        id: 0,
        ndescription: "",
        group: 1,
        subgroup: 1,
        clave: "",
        short_name: "",
        description: "",
        pos_note: "",
        waiter_commision: 0,
        barcode: "",
        prep_area: 1,
        image: "",
        image_mini: "",
        status: "ACTIVE",
        meal_type_id: null,
        loyalty_excluded: false,
        benefit_excluded: false,
        product_prices: [],
        product_modifiers: [],
        product_comments: [],
        product_personalization: [],
      },
      filteredProductPrices: [],
      pivotPrices: [],
      editProductPrice: {
        area_restaurant_id: 1,
        billable: false,
        id: 0,
        price: 0,
        price_wo_tax: 0,
        product_id: 0,
        tax: 0,
        tax_excempt: false,
      },
      sucursals: [],
      personalizations: [],

      prepareas: [],
      prepareasOptions: [],
      meal_types: [],
      mealtypesOptions: [],
      product_recipes: [],
      groups: [],
      groupOptions: [],
      optionRestAreas: [],
      subgroups: [],
      supplies: [],
      restAreas: [],
      optionSupplies: [],
      productExtraGroups: [],
      fieldsExtraGroups: [
        { key: "id", label: "ID" },
        { key: "name", label: "Nombre" },
        { key: "min_selection", label: "Min" },
        { key: "max_selection", label: "Max" },
        { key: "status", label: "Estado" },
        { key: "actions", label: "" },
      ],
      fieldsPersonalizations: [
        { key: "id", label: "ID" },
        { key: "personalization_id", label: "P.ID" },
        { key: "personalization.name", label: "Nombre" },
        { key: "default_selected", label: "Default" },
        { key: "edit", label: "" },
      ],
      fieldsPrices: [
        { key: "area_restaurant_id", label: "Area" },
        { key: "price", label: "Precio" },
        { key: "cost", label: "Costo" },
        // { key: "sucursal_id", label: "Sucursal" },
        { key: "edit_price", label: "" },
      ],
      fieldsPivotPrices: [],
      editingMasterPriceId: null,
      editingMasterPriceValue: 0,
      editingPivotKey: null,
      editingPivotValue: 0,
      savingPrice: false,
      batchArea: null,
      batchPriceValue: null,
      batchProcessing: false,
      totalCostByRecipe: null,
      fieldsRecipe: [
        { key: "supply_id", label: "Ingrediente" },
        { key: "supply.price", label: "Precio" },
        { key: "base_portion", label: "Porcion Base" },
        { key: "qty_portions", label: "Cant" },
        { key: "qty", label: "Total" },
        { key: "totalPrice", label: "Precio Total" },
        { key: "unit", label: "Unidad" },
        { key: "edit_supply", label: "" },
      ],
    };
  },
  beforeRouteUpdate(to, from) {
    console.log(to);
    console.log(from);
    this.initData(to.params.id);
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData(routeId) {
      console.log("creando");
      this.getProductGroups();
      this.getProductSubgroups();
      this.getRestAreas();
      this.getSupplies();
      this.getAllPersonalizations();
      this.getAllPrepAreas();
      this.getMealTypes()
      const productId = routeId !== undefined ? routeId : this.$route.params.id;
      console.log(productId);
      if (productId > 0) {
        console.log("producto no nuevo");
        this.actualProduct.id = productId;
        this.actualPersonalization.product_id = parseInt(this.actualProduct.id);
        this.getSucursales().then(() => {
          this.getProduct();
        });
        this.getProductExtraGroups();
      } else {
        this.getSucursales();
      }
      console.log("termina creacion");
    },

    getProductExtraGroups() {
      let that = this;
      axios
        .get("/product/" + this.actualProduct.id + "/extragroups")
        .then(function (response) {
          that.productExtraGroups = response.data;
        })
        .catch(function (err) {
          that.productExtraGroups = [];
          console.log("Extra groups not loaded", err);
        });
    },
    getMealTypes() {
      let that = this;
      axios
        .get("/mealtypes")
        .then(function (response) {
          that.meal_types = response.data;
          let persfil = response.data
            .map((pers) => {
              return { value: pers.id, text: pers.name };
            }).sort((a, b) => {
              return a.text.localeCompare(b.text);
            });
          that.mealtypesOptions = persfil;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllPersonalizations() {
      let that = this;
      axios
        .get("/personalizations")
        .then(function (response) {
          that.personalizations = response.data;
          let persfil = response.data
            .filter((pers) => {
              return pers.status;
            })
            .map((pers) => {
              return { value: pers.id, text: pers.name };
            }).sort((a, b) => {
              return a.text.localeCompare(b.text);
            });
          that.personalizationOptions = persfil;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllPrepAreas() {
      let that = this;
      axios
        .get("/preparationareas")
        .then(function (response) {
          that.prepareas = response.data;
          let persfil = response.data
            .filter((pers) => {
              return pers.status;
            })
            .map((pers) => {
              return { value: pers.id, text: pers.name };
            });
          that.prepareasOptions = persfil;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getSucursales() {
      let that = this;
      return axios
        .get("/sucursals")
        .then(function (response) {
          that.sucursals = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    createProductPersonalization() {
      let that = this;
      if (this.actualPersonalization.id > 0) {
        console.log("put productpers");
        axios
          .put(
            "/product/personalization/" + this.actualPersonalization.id,
            this.actualPersonalization
          )
          .then(function (response) {
            that.getAllPersonalizations();
            that.getProduct();
            that.makeToast("Exito", response.data.id, "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        console.log("post productpers");
        axios
          .post("/product/personalization", this.actualPersonalization)
          .then(function (response) {
            that.getAllPersonalizations();
            that.getProduct();

            that.makeToast("Exito", response.data.id, "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },
    createProductPrice() {
      let that = this;
      if (this.actualPrice.id > 0) {
        console.log("put productprice");
        axios
          .put("/product/price/" + this.actualPrice.id, this.actualPrice)
          .then(function (response) {
            that.getProduct();
            that.makeToast("Exito", response.data.id, "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
            that.getProduct();
          });
      } else {
        console.log("post productprice");
        axios
          .post("/product/price", this.actualPrice)
          .then(function (response) {
            that.getProduct();
            that.makeToast("Exito", response.data.id, "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
            that.getProduct();
          });
      }
    },
    defaultProductPrice() {
      this.actualPrice = {
        id: 0,
        product_id: this.actualProduct.id,
        area_restaurant_id: 0,
        price: 0,
        price_wo_tax: 0,
        tax: 0,
        tax_excempt: false,
        billable: true,
      };
    },
    openModalPersonalization(pid) {
      this.$bvModal.show("modal-addPersonalization");
      this.actualPersonalization.id = pid;
    },
    openModalRecipe(pid) {
      this.$bvModal.show("modal-addRecipe");
      if (pid.id == 0) {
        this.defaultProductRecipe();
      } else {
        this.actualRecipe = pid;
      }
    },
    defaultProductRecipe() {
      this.actualRecipe = {
        id: 0,
        product_id: this.actualProduct.id,
        supply_id: null,
        qty_portions: 0,
      };
    },
    createProductRecipe() {
      let that = this;
      console.log(this.actualRecipe);
      if (this.actualRecipe.id > 0) {
        console.log("put createProductRecipe");
        axios
          .put("/recipe/" + this.actualRecipe.id, this.actualRecipe)
          .then(function (response) {
            that.getProductRecipe();
            that.makeToast("Exito", response.data.id, "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
            that.getProductRecipe();
          });
      } else {
        console.log("post createProductRecipe");
        axios
          .post("/recipe", this.actualRecipe)
          .then(function (response) {
            that.getProductRecipe();
            that.makeToast("Exito", response.data.id, "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
            that.getProductRecipe();
          });
      }
    },
    deleteProductRecipe(pid) {
      let that = this
      axios
        .delete("/recipe/" + pid.id, this.actualRecipe)
        .then(function (response) {
          that.getProductRecipe();
          that.makeToast("Exito", response.data.id, "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
          that.getProductRecipe();
        });
    },
    deleteProductPrice(pid) {
      let that = this
      axios
        .delete("/product/price/" + pid.id)
        .then(function (response) {
          that.getProduct();
          that.makeToast("Exito", response.data.id, "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
          that.getProduct();
        });
    },
    startEditMasterPrice(item) {
      this.editingMasterPriceId = item.id;
      this.editingMasterPriceValue = item.price;
    },
    cancelMasterPriceInline() {
      this.editingMasterPriceId = null;
      this.editingMasterPriceValue = 0;
    },
    saveMasterPriceInline(item) {
      if (this.editingMasterPriceId === null) return;
      var savedValue = this.editingMasterPriceValue;
      if (savedValue === item.price) {
        this.cancelMasterPriceInline();
        return;
      }
      this.editingMasterPriceId = null;
      let that = this;
      let updatedPrice = Object.assign({}, item, { price: savedValue });
      this.savingPrice = true;
      axios
        .put("/product/price/" + item.id, updatedPrice)
        .then(function () {
          that.cancelMasterPriceInline();
          that.getProduct();
          that.makeToast("Exito", "Precio actualizado", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(function () {
          that.savingPrice = false;
        });
    },
    startEditPivotPrice(item, area) {
      if (!item['s' + area.id]) {
        this.openModalPriceByPriceArea({ area_restaurant_id: area.id, sucursal_id: item.sucursal_id });
        return;
      }
      this.editingPivotKey = item.sucursal_id + '-' + area.id;
      this.editingPivotValue = item[area.id] || 0;
    },
    cancelPivotPriceInline() {
      this.editingPivotKey = null;
      this.editingPivotValue = 0;
    },
    savePivotPriceInline(item, area) {
      if (this.editingPivotKey === null) return;
      var currentPrice = item[area.id];
      var savedValue = this.editingPivotValue;
      if (savedValue === currentPrice) {
        this.cancelPivotPriceInline();
        return;
      }
      var priceId = item['pid' + area.id];
      var followsAlready = item['f' + area.id];
      this.editingPivotKey = null;
      let that = this;

      // Check if new value matches master price
      var masterPrice = this.filteredProductPrices.find(function (p) { return p.area_restaurant_id === area.id; });
      if (masterPrice && savedValue === masterPrice.price && !followsAlready) {
        this.$bvModal.msgBoxConfirm(
          'El precio que ingresaste es igual al precio master ($' + masterPrice.price + '). ¿Deseas que esta sucursal siga el precio master? Si eliges "No", se mantendra como precio unico.',
          {
            title: 'Seguir precio master?',
            okTitle: 'Si, seguir master',
            cancelTitle: 'No, mantener unico',
            okVariant: 'success',
            cancelVariant: 'danger',
            centered: true,
          }
        ).then(function (followMaster) {
          that.executePivotSave(item, area, priceId, followMaster === true, savedValue);
        });
        return;
      }

      this.executePivotSave(item, area, priceId, false, savedValue);
    },
    executePivotSave(item, area, priceId, followMaster, priceValue) {
      let that = this;
      if (priceId) {
        var priceRecord = this.actualProduct.product_prices.find(function (x) { return x.id === priceId; });
        if (!priceRecord) { that.cancelPivotPriceInline(); return; }
        var updatedPrice = Object.assign({}, priceRecord, { price: priceValue, follow_price: followMaster });
        this.savingPrice = true;
        axios
          .put("/product/price/" + priceId, updatedPrice)
          .then(function () {
            that.cancelPivotPriceInline();
            that.getProduct();
            that.makeToast("Exito", "Precio actualizado" + (followMaster ? " (sigue master)" : ""), "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          })
          .finally(function () { that.savingPrice = false; });
      } else {
        var newPrice = {
          id: 0,
          product_id: this.actualProduct.id,
          area_restaurant_id: area.id,
          sucursal_id: item.sucursal_id,
          price: priceValue,
          price_wo_tax: 0,
          tax: 0,
          tax_excempt: false,
          billable: true,
          follow_price: followMaster,
          status: true,
        };
        this.savingPrice = true;
        axios
          .post("/product/price", newPrice)
          .then(function () {
            that.cancelPivotPriceInline();
            that.getProduct();
            that.makeToast("Exito", "Precio creado" + (followMaster ? " (sigue master)" : ""), "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          })
          .finally(function () { that.savingPrice = false; });
      }
    },
    batchFollowMaster() {
      let that = this;
      var areaId = this.batchArea;
      var allPrices = this.actualProduct.product_prices || [];
      var targets = allPrices.filter(function (p) {
        return p.sucursal_id != null && p.area_restaurant_id === areaId && !p.follow_price;
      });
      if (targets.length === 0) {
        this.makeToast("Info", "Todas las sucursales ya siguen el master", "info");
        return;
      }
      this.batchProcessing = true;
      var promises = targets.map(function (p) {
        var updated = Object.assign({}, p, { follow_price: true });
        return axios.put("/product/price/" + p.id, updated);
      });
      Promise.all(promises)
        .then(function () {
          that.getProduct();
          that.makeToast("Exito", targets.length + " precios actualizados a seguir master", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(function () { that.batchProcessing = false; });
    },
    batchSetPrice() {
      let that = this;
      var areaId = this.batchArea;
      var newPrice = this.batchPriceValue;
      var allPrices = this.actualProduct.product_prices || [];
      var targets = allPrices.filter(function (p) {
        return p.sucursal_id != null && p.area_restaurant_id === areaId;
      });
      if (targets.length === 0) {
        this.makeToast("Info", "No hay precios de sucursal para esta area", "info");
        return;
      }
      this.batchProcessing = true;
      var promises = targets.map(function (p) {
        var updated = Object.assign({}, p, { price: newPrice, follow_price: false });
        return axios.put("/product/price/" + p.id, updated);
      });
      Promise.all(promises)
        .then(function () {
          that.getProduct();
          that.batchPriceValue = null;
          that.makeToast("Exito", targets.length + " precios actualizados a $" + newPrice, "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(function () { that.batchProcessing = false; });
    },
    batchToggleStatus(enable) {
      let that = this;
      var areaId = this.batchArea;
      var allPrices = this.actualProduct.product_prices || [];
      var targets = allPrices.filter(function (p) {
        return p.sucursal_id != null && p.area_restaurant_id === areaId && p.status !== enable;
      });
      if (targets.length === 0) {
        this.makeToast("Info", "Todas las sucursales ya tienen ese status", "info");
        return;
      }
      this.batchProcessing = true;
      var promises = targets.map(function (p) {
        var updated = Object.assign({}, p, { status: enable });
        return axios.put("/product/price/" + p.id, updated);
      });
      Promise.all(promises)
        .then(function () {
          that.getProduct();
          that.makeToast("Exito", targets.length + " precios " + (enable ? "habilitados" : "deshabilitados"), "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(function () { that.batchProcessing = false; });
    },
    deleteProductPersonalization(pid) {
      let that = this
      axios
        .delete("/product/personalization/" + pid.id)
        .then(function (response) {
          that.getProduct();
          that.makeToast("Exito", response.data.id, "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
          that.getProduct();
        });
    },
    openModalPrice(pid) {
      this.$bvModal.show("modal-price");
      if (pid.id == 0) {
        this.defaultProductPrice();
      } else {
        this.actualPrice = this.actualProduct.product_prices.find(x => x.id == pid.id)
        if (this.actualPrice == undefined) {
          this.defaultProductPrice()
        }
      }
    },
    openModalPriceByPriceArea(pid) {
      let r = this.actualProduct.product_prices
      console.log(r)
      console.log("openModalPriceByPriceArea")
      console.log(pid.area_restaurant_id + " - " + pid.sucursal_id)
      console.log(r)
      let t = r.find(function (x) { return x.area_restaurant_id == pid.area_restaurant_id && x.sucursal_id == pid.sucursal_id })
      this.actualPrice = t
      if (this.actualPrice == undefined) {
        this.defaultProductPrice()
        this.actualPrice.area_restaurant_id = pid.area_restaurant_id
        this.actualPrice.sucursal_id = pid.sucursal_id
        this.actualPrice.product_id = this.actualProduct.id
      }
      this.$bvModal.show("modal-price");
      console.log("end modal open")
    },
    newUser(event) {
      event.preventDefault();
      let that = this;
      axios
        .post("/user", this.newuser)
        .then(function (data) {
          that.makeToast(
            "Exito",
            data.response.username + " creado",
            "success"
          );
          that.cleanNewUser();
          that.getAllUsers();
          that.search = data.response.username;
        })
        .catch(function (err) {
          console.log(err.request.response);
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getProduct() {
      let that = this;
      axios
        .get("/product/" + this.actualProduct.id)
        .then(function (response) {
          var r = response.data;
          that.actualProduct = r;
          var allPrices = r.product_prices || [];

          // Master prices (no sucursal)
          that.filteredProductPrices = allPrices.filter(function (p) { return p.sucursal_id == null; });

          // Pivot prices (branch-specific) - reduce into pivot rows
          var branchPrices = allPrices.filter(function (p) { return p.sucursal_id != null; });
          var pivotMap = {};
          branchPrices.forEach(function (y) {
            var key = y.sucursal_id;
            if (!(key in pivotMap)) pivotMap[key] = { sucursal_id: y.sucursal_id };
            pivotMap[key][y.area_restaurant_id] = y.price;
            pivotMap[key]["s" + y.area_restaurant_id] = y.status;
            pivotMap[key]["f" + y.area_restaurant_id] = y.follow_price;
            pivotMap[key]["pid" + y.area_restaurant_id] = y.id;
          });
          // Ensure all sucursales of the same company appear, even without prices
          that.sucursals.forEach(function (suc) {
            if (suc.company_id === r.company_id && !(suc.id in pivotMap)) {
              pivotMap[suc.id] = { sucursal_id: suc.id };
            }
          });
          that.pivotPrices = Object.values(pivotMap).sort(function (a, b) {
            var nameA = (that.searchSucursal(a.sucursal_id).nombre || '').toLowerCase();
            var nameB = (that.searchSucursal(b.sucursal_id).nombre || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
        })
        .catch(function (err) {
          console.log(err);
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getProductRecipe() {
      let that = this;
      axios
        .get("/product/" + this.actualProduct.id + "/recipe")
        .then(function (response) {
          let totalCost = 0
          that.product_recipes = response.data.map((x) => {
            x.supply = that.searchSupply(x.supply_id);
            if (!x.supply._missing) {
              totalCost += x.supply.price * x.qty_portions * x.supply.base_portion
            }
            return x;
          });
          that.totalCostByRecipe = totalCost.toFixed(2)
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getProductGroups() {
      let that = this;
      axios
        .get("/groups")
        .then(function (response) {
          that.groups = response.data;
          that.groupOptions = response.data.map(function (act) {
            return { value: act.id, text: act.name };
          });
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getProductSubgroups() {
      let that = this;
      axios
        .get("/subgroups")
        .then(function (response) {
          that.subgroups = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    searchSupply(id) {
      const found = this.supplies.find((element) => element.id == id);
      if (found) return found;
      return {
        name: "Insumo no disponible",
        price: 0,
        base_portion: 0,
        unit: "",
        _missing: true,
      };
    },
    getSupplies() {
      let that = this;
      axios
        .get("/supplies")
        .then(function (response) {
          // Keep the full list so searchSupply(id) can still resolve the name of an
          // already-saved recipe line that points at an inactive supply.
          that.supplies = response.data;
          // The dropdown for ADDING / changing a recipe line shows only active supplies
          // — inactive ones must not be selectable going forward.
          that.optionSupplies = response.data
            .filter((x) => x.status)
            .sort(function (a, b) {
              return a.name.localeCompare(b.name);
            })
            .map((x) => {
              return {
                value: x.id,
                label: x.code+" "+x.name + " (Base" + x.base_portion + " " + x.unit + ")",
              };
            });
          if (that.$route.params.id > 0) {
            that.getProductRecipe();
          }
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    searchRestArea(id) {
      return (
        this.restAreas.find((element) => element.id == id) || { name: "error" }
      );
    },
    searchSucursal(id) {
      return (
        this.sucursals.find((element) => element.id == id) || { nombre: "error" }
      );
    },
    getRestAreas() {
      let that = this;
      axios
        .get("/restaurant/areas")
        .then(function (response) {
          that.restAreas = response.data;
          that.optionRestAreas = response.data.map((x) => {
            return { value: x.id, text: x.name };
          });
          let s = [{ key: "sucursal_id", label: "sucursal", sortable: true, stickyColumn:true },]
          response.data.map((x) => {
            s.push({ key: x.id.toString(), label: x.name })
            return { key: x.id, label: x.name };
          });
          that.fieldsPivotPrices = s

        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    updateProduct() {
      let that = this;
      if (this.actualProduct.id > 0) {
        axios
          .put("/product/" + this.actualProduct.id, this.actualProduct)
          .then(function (response) {
            that.actualProduct = response.data;
            that.makeToast("Exito", "exito al guardar", "success");
            that.getProduct();
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        axios
          .post("/product", this.actualProduct)
          .then(function (response) {
            that.makeToast("Exito", "exito al crear, redirigiendo", "success");
            console.log(response.data);
            that.$router.push({
              name: "Product",
              params: { id: response.data.id },
            });
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },

    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
<style scoped>
.hover-highlight:hover {
  background-color: rgba(0, 123, 255, 0.08);
}
.product-image-preview {
  width: 100%;
  max-width: 320px;
}
.pivot-prices-table .badge {
  transition: opacity 0.15s;
}
.pivot-prices-table .badge:hover {
  opacity: 0.85;
}
</style>
